import buttonGenerator from './buttonGenerator';
export const Default = buttonGenerator('defaultButton', 'default');
export const Primary = buttonGenerator('defaultButton', 'primary');
export const Destructive = buttonGenerator('defaultButton', 'destructive');
export const Safe = buttonGenerator('defaultButton', 'safe');
export const Outline = buttonGenerator('defaultButton', 'outline');
export const OutlinePrimary = buttonGenerator('defaultButton', 'outlinePrimary');
export const OutlineBasic = buttonGenerator('defaultButton', 'outlineBasic');
export const Yellow = buttonGenerator('defaultButton', 'yellow');
//# sourceMappingURL=Button.js.map